/*! JM Live Preview — Photo add-on v1.33: one finished photo per month and metal (e.g. Mini Pavé Date necklace / bracelet).
 * Switched on by product metafield custom.preview_layout = "photo"; loaded from snippets/jm-tennis-preview.liquid.
 * The stone picker swaps the whole photo (no compositing): photo = custom.preview_photos pattern in Content > Files
 * (e.g. mpdn-{metal}-{mon}.png) when set, otherwise that month's variant photo in the chosen metal.
 * Swatches: {prefix}-swatch-{metal}-{mon}.png in Content > Files (prefix = custom.preview_prefix).
 * Mini-preview / cart thumbnail square: custom.preview_split {"focus":[x, y, size]} as fractions of the photo. */
(function () {
  'use strict';
  var cache = {};
  function canvasOf(url) {
    if (!cache[url]) {
      cache[url] = new Promise(function (res, rej) {
        var i = new Image(); i.crossOrigin = 'anonymous'; i.decoding = 'async';
        i.onload = function () { var c = document.createElement('canvas'); c.width = i.naturalWidth; c.height = i.naturalHeight; c.getContext('2d').drawImage(i, 0, 0); res(c); };
        i.onerror = rej; i.src = url;
      });
      cache[url].catch(function () { delete cache[url]; });
    }
    return cache[url];
  }
  function patch(p) {
    p.single = true;
    p.countIdx = -1;
    p.cfg.maxStones = 1;
    p.state.count = 1;
    p.photoFor = function (metal, mIdx) {
      if (this.cfg.photos) return this.fileUrl(this.cfg.photos, metal, mIdx, 1600);
      var v = this.variantImage(metal, mIdx) || this.variantImage(null, mIdx);
      return v ? v.replace(/width=\d+/, 'width=1600') : null;
    };
    p.renderVariantPhotos = function (token) {
      var self = this, mIdx = this.state.stones[0], url = this.photoFor(this.state.metal, mIdx);
      if (!url) return Promise.reject(new Error('missing month photo'));
      return canvasOf(url).then(function (A) {
        if (token !== self.renderToken) return;
        var W = A.width, H = A.height, cv = self.canvas;
        if (!cv) { cv = self.canvas = document.createElement('canvas'); cv.className = 'jmlp__canvas'; cv.setAttribute('role', 'img'); self.stage.insertBefore(cv, self.layersEl); }
        cv.width = W; cv.height = H;
        cv.setAttribute('aria-label', self.recipe().stones.map(function (s) { return s.label; }).join(', '));
        cv.getContext('2d').drawImage(A, 0, 0);
        var fz = (self.cfg.splitCfg && self.cfg.splitCfg.focus) || [0.5, 0.5, 0.6];
        var fs = Math.min(W, H, W * (fz[2] || 0.6));
        self.focus = { x: Math.max(0, Math.min(W - fs, W * fz[0] - fs / 2)), y: Math.max(0, Math.min(H - fs, H * fz[1] - fs / 2)), s: fs };
        self.paintCopies();
        self.stage.classList.add('jmlp__stage--canvas');
        // warm the neighbouring months so the next tap feels instant
        [-1, 1].forEach(function (d) {
          var u = self.photoFor(self.state.metal, (mIdx + d + 12) % 12);
          if (u) canvasOf(u).catch(function () {});
        });
      });
    };
    p.syncFromVariant(true);
  }
  var tries = 0;
  (function wait() {
    var L = window.JMLivePreview, done = false;
    if (L) Object.keys(L).forEach(function (id) {
      var p = L[id];
      if (!p || id === '_tools' || !p.cfg) return;
      done = true;
      if (!p.__photo && p.cfg.layout === 'photo') { p.__photo = true; try { patch(p); } catch (e) { console.error('[JM Photo]', e); } }
    });
    if (!done && ++tries < 60) setTimeout(wait, 100);
  })();
})();
